/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookAppointmentDto
 */
export interface BookAppointmentDto {
    /**
     * ISO date string
     * @type {string}
     * @memberof BookAppointmentDto
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof BookAppointmentDto
     */
    providerId: string;
    /**
     * 
     * @type {string}
     * @memberof BookAppointmentDto
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof BookAppointmentDto
     */
    notes?: string;
}

/**
 * Check if a given object implements the BookAppointmentDto interface.
 */
export function instanceOfBookAppointmentDto(value: object): value is BookAppointmentDto {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('providerId' in value) || value['providerId'] === undefined) return false;
    return true;
}

export function BookAppointmentDtoFromJSON(json: any): BookAppointmentDto {
    return BookAppointmentDtoFromJSONTyped(json, false);
}

export function BookAppointmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookAppointmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'providerId': json['providerId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function BookAppointmentDtoToJSON(json: any): BookAppointmentDto {
    return BookAppointmentDtoToJSONTyped(json, false);
}

export function BookAppointmentDtoToJSONTyped(value?: BookAppointmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'providerId': value['providerId'],
        'reason': value['reason'],
        'notes': value['notes'],
    };
}

